export const CLIENT_ORGANISATION = "Organisations::ClientOrganisation";

export const AUDIT_ORGANISATION = "Organisations::AuditOrganisation";

export const DELEGATED_AUDIT_ORGANISATION = "Organisations::DelegatedAuditOrganisation";
